var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Lautsprecher_on"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lautsprecher_on",
    clipPath: "url(#clip-Lautsprecher_on)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_",
    transform: "translate(22.07 6.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_",
    transform: "translate(16 37.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1243_",
    d: "M16,54.692V82.76H36.669l17.859,17.449,5.086.043V37.2l-5.086.014L36.669,54.692Z",
    transform: "translate(-16 -37.2)",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_",
    transform: "translate(70.623 49.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    d: "M350.534,108.74c7.2,2.5,13.129,10.389,13.129,19.665,0,8.465-4.937,15.773-13.147,19.673",
    transform: "translate(-344.426 -108.74)",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_2",
    d: "M350.526,108.74A11.892,11.892,0,0,1,358,119.93c0,4.817-2.809,8.975-7.481,11.194",
    transform: "translate(-350.516 -100.264)",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.cefc4d8ae4c8f049579a8259143df476.svg";
export { ForwardRef as ReactComponent };